import { splitLines } from './sentenceSearchRepository';

/** Read an NDJSON response to its end, handing each line's event to `onEvent` as it arrives. */
export async function readNdjsonStream<E>(response: Response, onEvent: (event: E) => void): Promise<void> {
  if (!response.body) throw new Error('The request returned no stream');
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let rest = '';
  const consume = (lines: string[]) => { for (const line of lines) onEvent(JSON.parse(line) as E); };
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    const split = splitLines(rest, decoder.decode(value, { stream: true }));
    rest = split.rest;
    consume(split.lines);
  }
  consume(splitLines(rest, decoder.decode() + '\n').lines);
}
